<template>
  <v-container>
    <v-breadcrumbs
      class="px-0 py-2"
      :items="breadcrumbs"
    />
    <h2>
      積替運搬編集
    </h2>
    <order-request-form :editMode="editMode" />
  </v-container>
</template>
<script>
import OrderRequestForm from './_Form'

export default {
  name: 'OrderRequestCollectionEdit',
  components: {
    OrderRequestForm
  },
  mixins: [],
  props: {},
  data() {
    return {
      editMode: true,
      breadcrumbs: [
        { text: '発注（積替・搬入）', disabled: false, to: '/driver/orders/requests', exact: true },
        { text: '積替運搬編集', disabled: true, to: '' },
      ]
    }
  },
  computed: {},
  watch: {},
  created() {},
  methods: {}
}
</script>
